export const TICKETS_ON_GET_ALL_REQUESTED = 'TICKETS_ON_GET_ALL_REQUESTED';
export const TICKETS_ON_GET_ALL_SUCCEEDED = 'TICKETS_ON_GET_ALL_SUCCEEDED';
export const TICKETS_ON_GET_ALL_FAILED = 'TICKETS_ON_GET_ALL_FAILED';

export const PRODUCTS_ON_GET_ALL_REQUESTED = 'PRODUCTS_ON_GET_ALL_REQUESTED';
export const PRODUCTS_ON_GET_ALL_SUCCEEDED = 'PRODUCTS_ON_GET_ALL_SUCCEEDED';
export const PRODUCTS_ON_GET_ALL_FAILED = 'PRODUCTS_ON_GET_ALL_FAILED';

export const TAREAS_ON_GET_ALL_REQUESTED = 'TAREAS_ON_GET_ALL_REQUESTED';
export const TAREAS_ON_GET_ALL_SUCCEEDED = 'TAREAS_ON_GET_ALL_SUCCEEDED';
export const TAREAS_ON_GET_ALL_FAILED = 'TAREAS_ON_GET_ALL_FAILED';

export const RESOURCES_ON_GET_ALL_REQUESTED = 'RESOURCES_ON_GET_ALL_REQUESTED';
export const RESOURCES_ON_GET_ALL_SUCCEEDED = 'RESOURCES_ON_GET_ALL_SUCCEEDED';
export const RESOURCES_ON_GET_ALL_FAILED = 'RESOURCES_ON_GET_ALL_FAILED';

export const CLIENTS_ON_GET_ALL_REQUESTED = 'CLIENTS_ON_GET_ALL_REQUESTED';
export const CLIENTS_ON_GET_ALL_SUCCEEDED = 'CLIENTS_ON_GET_ALL_SUCCEEDED';
export const CLIENTS_ON_GET_ALL_FAILED = 'CLIENTS_ON_GET_ALL_FAILED';